import { Heading } from "@tokenterminal/core/ui/heading/Heading"
import { toSlug } from "modules/market-sectors/utils"
import useMetricsConfigurationBySlug from "modules/projects/OverviewTab/useMetricsConfigurationBySlug"
import ScreenerTable from "modules/screener/ScreenerTable"
import { Suspense, useState } from "react"

// Helper function to map metric format to valid cell data types
const getValidCellDataType = (format: string): string => {
  const formatMap: Record<string, string> = {
    price: "price",
    currency: "currency",
    number: "number",
    percentage: "percentage",
    percent: "percentage",
    ratio: "ratio",
    time: "time",
  }

  return formatMap[format] || "number"
}

export const ProjectsTable = ({
  metricId,
  isStatic,
}: {
  metricId: string
  isStatic: boolean
}) => {
  const metricConfiguration = useMetricsConfigurationBySlug(toSlug(metricId))
  const [chainIds, setChainIds] = useState<string[]>([])
  const [marketSectorSlugs, setMarketSectorSlugs] = useState<string[]>([])

  // Convert metric ID format for field names
  const field = `${metricId}_30d_${isStatic ? "latest" : "sum"}`
  const changeField = `${metricId}_30d_${isStatic ? "change" : "trend"}`

  return (
    <div className="w-full">
      <div className="flex flex-col gap-4 w-full">
        <Suspense fallback={<div>Loading projects...</div>}>
          <ScreenerTable
            header={<Heading level={3}>Projects</Heading>}
            showPresetSelector={false}
            disableUrlState
            hideEditColumns
            hideMarketSectorDropdown
            hideColumnFilters
            presetOverride={{
              name: "Metric Projects",
              columns: [
                {
                  field: "market_sectors",
                  default_size: 150,
                },
                {
                  field: "definition",
                  header: "Definition",
                  default_size: 400,
                  virtual_field: true,
                  group_override: "Definition",
                  metadata: {
                    metric_id: metricId,
                    metric_title: metricConfiguration?.title,
                  },
                },
                {
                  field,
                  cell_data_type: getValidCellDataType(
                    metricConfiguration?.format || "number"
                  ),
                },

                {
                  field: changeField,
                  cell_data_type: "trend",
                },
              ],
              filters: {
                sort: [
                  {
                    id: field,
                    desc: true,
                  },
                ],
                filters: [
                  {
                    field,
                    operator: "exists",
                    value: 0,
                  },
                ],
                chains: chainIds,
                market_sectors: marketSectorSlugs,
                column_sizing: {
                  market_sectors: 150,
                  definition: 400,
                  [field]: 120,
                  [changeField]: 100,
                },
              },
            }}
          />
        </Suspense>
      </div>
    </div>
  )
}
